import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';
import { bootstrapApp } from '@/app/bootstrap';
import { env } from '@/shared/config/env';
import { initPwa } from '@/shared/pwa';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Falta el contenedor #root en index.html');

const root = createRoot(container);

void bootstrapApp().then(() =>
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  ),
);

if (env.isProd) initPwa();
